export const categoryList = [
    {
        id: 1,
        name: "BEDSHEET SET",
        imageUrl: "Bedsheets-category",
        link: "https://shop.sansaar.co.in/collections/bedsheet-set",
        icon: "bedsheet"
    }, {
        id: 2,
        name: "BEDSPREADS",
        imageUrl: "Bedspread-category",
        link: "https://shop.sansaar.co.in/collections/bedspreads",
        icon: "cushion-cover"
    }, {
        id: 3,
        name: "DUVET COVERS",
        imageUrl: "Duvet-Cover-category",
        link: "https://shop.sansaar.co.in/collections/duvet-covers",
        icon: "duvet"
    }, {
        id: 4,
        name: "COMFORTERS",
        imageUrl: "Comforters-category",
        link: "https://shop.sansaar.co.in/collections/comforters",
        icon: "comfortor"
    }, {
        id: 5,
        name: "Bedding Set",
        imageUrl: "Bed-in-a-Bag-category",
        link: "https://shop.sansaar.co.in/collections/shop-the-look",
        icon: "bed-in-bag"
    }, {
        id: 6,
        name: "PILLOW COVER",
        imageUrl: "Pillow-Cover-category",
        link: "https://shop.sansaar.co.in/collections/pillow-covers",
        icon: "pillow-cover"
    }
]

export const defaultSEO = {
    pageTitle: "Sansaar - A D'Decor Brand",
    metaDescription: "Sansaar - A D'Decor Brand - Live Consciously",
    metaKeywords: "Sansaar, D'Decor, home decor, fabrics, bedding, curtains, cushions, conscious living",
    canonical: "https://sansaar.co.in/"
}